// After the agent persists a blueprint (a successful save_blueprint tool
// event), the running editor session must be told — nothing else watches for
// server-side blueprint changes (no polling, no push; see CLAUDE.md
// Persistence). This module is the pure decision of HOW, unit-testable apart
// from the panel.
//
// The rule protects unsaved local work: the agent's save was composed from the
// SERVER copy plus its own edits, never from the browser's unsaved graphs, so a
// blind reload can clobber what the user was typing.
//
//   editor closed → reload silently (loadBlueprintFromDB). Graph edits happen
//     in the editor; with it closed there is no in-flight local work to lose.
//   editor open   → prompt. The user may be mid-edit; they choose Reload (the
//     same path as File ▸ Load from Cloud) or keep their local state.

/** @returns {'auto-reload' | 'prompt'} */
export function decideBlueprintRefresh({ editorOpen }) {
  return editorOpen ? 'prompt' : 'auto-reload'
}

/** True when this agent event means the server blueprint changed. */
export function isBlueprintSaveEvent(event) {
  return event?.type === 'tool-result' && event.name === 'save_blueprint' && event.ok === true
}

// Material rows have their own live-reload path: __RELOAD_MATERIALS__
// re-fetches and rebinds, the same hook every Inspector PATCH uses. Unlike
// blueprints there is no unsaved-local-edits hazard (material edits commit on
// PATCH), so the panel always reloads — the only question is which events
// mean "a material row changed on the server".
const MATERIAL_TOOLS = new Set(['update_material', 'create_material', 'set_material_mapping'])

/** True when this agent event means a material row changed server-side. */
export function isMaterialToolEvent(event) {
  return event?.type === 'tool-result' && event.ok === true && MATERIAL_TOOLS.has(event.name)
}
